export const ConvertObjToArray = (jsonData: any): any[] => {
    const dataArray: any[] = []

    Object.keys(jsonData).forEach((key) => {
        dataArray.push({
            key: key,
            ...jsonData[key]
        })
    })

    return dataArray
}
